import { ConsignmentForm } from '@/types/Consignment';
import { getBaseUrl } from '@/redux/modules/config';
import { getBidderEmail, isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import { getSeller } from '@/redux/modules/seller';
import { getSubmitConsignment, submitConsignment } from '@/redux/modules/consignment';
import { openConfirmConsignmentModal } from '@/redux/modules/modal';
import { recordAnalyticsForConsignmentsPageView } from '@/redux/modules/analytics';
import { sellerIdFromPath } from '@/utils/urls';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { useLocation, useParams } from 'react-router-dom';
import { waitToDispatch } from '@/utils/waitToDispatch/waitToDispatch';
import ConsignmentsPage from './ConsignmentsPage';
import React, { useCallback } from 'react';

type ConsignmentsPathParams = {
    sellerId?: string;
};

const ConsigmentsPageContainer = () => {
    const params = useParams<ConsignmentsPathParams>();
    const dispatch = useAppDispatch();
    const location = useLocation();

    const sellerId = sellerIdFromPath(params?.sellerId);

    const baseUrl = useAppSelector(getBaseUrl);
    const submitConsignmentStatus = useAppSelector(getSubmitConsignment);
    const seller = useAppSelector((state) => getSeller(state, sellerId));
    const userLoggedIn = useAppSelector(isUserLoggedIn);
    const emailAddress = useAppSelector(getBidderEmail);

    React.useEffect(() => {
        waitToDispatch(recordAnalyticsForConsignmentsPageView, dispatch, location);
    }, [dispatch, location]);

    const openModal = useCallback(() => {
        dispatch(openConfirmConsignmentModal());
    }, [dispatch]);

    return (
        <ConsignmentsPage
            baseUrl={baseUrl}
            emailAddress={emailAddress}
            openConfirmConsignmentModal={openModal}
            seller={seller}
            sellerId={sellerId}
            submitConsignment={(consignmentDetails: ConsignmentForm, file: File) =>
                dispatch(submitConsignment(consignmentDetails, file))
            }
            submitConsignmentStatus={submitConsignmentStatus}
            userLoggedIn={userLoggedIn}
        />
    );
};

export default ConsigmentsPageContainer;
